<template>
  <div class="order order-record">
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>道路:</label>
          <search-parking></search-parking>
        </div>
        <div class="form-group">
          <label for>岗位:</label>
          <search-area></search-area>
        </div>
        <div class="form-group">
          <label for>订单号:</label>
          <input
            v-model="search.orderNum"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>车牌:</label>
          <input
            v-model="search.carNumber"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>泊位号:</label>
          <input
            v-model="search.spaceNum"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>订单状态:</label>
          <el-select
            clearable
            v-model="search.orderStatus"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in allOrderStatus.rows"
              :key="index"
              :label="item.labelDefault"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for>订单类型:</label>
          <el-select clearable v-model="search.orderType" placeholder="请选择">
            <el-option
              v-for="(item, index) in allOrderType"
              :key="index"
              :label="item.labelDefault"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for>支付类型:</label>
          <el-select clearable v-model="search.payType" placeholder="请选择">
            <el-option
              v-for="(item, index) in allPayTypes"
              :key="index"
              :label="item.label"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for>第三方支付单号:</label>
          <input
            v-model="search.attr3"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>超时录入（分钟）:</label>
          <el-select clearable v-model="search.overTime" placeholder="请选择">
            <el-option
              v-for="item in [10, 20, 30]"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="form-group">
          <label for>手机号:</label>
          <input
            v-model="search.phone"
            class="form-control"
            type="text"
            size="12"
          />
        </div>
        <div class="form-group">
          <label for="bdate">入场时间:</label>
          <!-- <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm"
            v-model="search.beginDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker> -->
          <bosk-shortcut-datetime
            v-on:current-datetime-change="
              (v) => onCurrentDatetimeChange(v, 'beginTime')
            "
          ></bosk-shortcut-datetime>
        </div>
        <div class="form-group">
          <label for="bdate">下单时间:</label>
          <bosk-shortcut-datetime
            v-on:current-datetime-change="
              (v) => onCurrentDatetimeChange(v, 'crtTime')
            "
          ></bosk-shortcut-datetime>
        </div>
        <div class="form-group">
          <label for>下单收费员:</label>
          <el-select
            clearable
            filterable
            v-model="search.crtUser"
            placeholder="请选择"
            @focus="getAllChargeUsers"
          >
            <el-option
              v-for="(item, index) in allChargeUsers"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for="bdate">结算时间:</label>
          <!-- <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm"
            v-model="search.chargeDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker> -->
          <bosk-shortcut-datetime
            v-on:current-datetime-change="
              (v) => onCurrentDatetimeChange(v, 'chargeDate')
            "
          ></bosk-shortcut-datetime>
        </div>
        <div class="form-group">
          <label for>结算收费员:</label>
          <el-select
            clearable
            filterable
            v-model="search.chargeId"
            placeholder="请选择"
            @focus="getAllChargeUsers"
          >
            <el-option
              v-for="(item, index) in allChargeUsers"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <!-- <div v-if="systemConfigData.ORDER_SEARCH_PLACE_TIME" class="form-group">
          <label for="bdate">下单时间:</label>
           <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm"
            v-model="search.crtTimeData"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
          <bosk-shortcut-datetime
            v-on:current-datetime-change="
              (v) => onCurrentDatetimeChange(v, 'crtTimeData')
            "
          ></bosk-shortcut-datetime>
        </div> -->

        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <span class="download_btn">
            <el-button type="primary" size="small" @click="downloadExcel"
              >导出EXCEL</el-button
            >
          </span>
          <span
            class="batchDel_btn gap"
            :style="{
              cursor: canBatchCancel ? 'not-allowed' : 'pointer',
            }"
          >
            <button
              v-if="buttonPermissions.btn_clear"
              type="button"
              :class="['btn', 'btn-default', canBatchCancel ? 'is-gray' : '']"
              @click="executeBatchEliminate"
              :disabled="canBatchCancel"
            >
              批量冲销
            </button>
          </span>
          <span
            class="batchDel_btn"
            :style="{
              cursor: canBatchException ? 'not-allowed' : 'pointer',
            }"
          >
            <button
              v-if="buttonPermissions.btn_del"
              type="button"
              :class="[
                'btn',
                'btn-default',
                canBatchException ? 'is-gray' : '',
              ]"
              @click="executeBatchDel"
              :disabled="canBatchException"
            >
              批量删除
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        @selection-change="onSelectionChange"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55px"
        ></el-table-column>
        <el-table-column
          width="180px"
          show-overflow-tooltip
          label="停车道路"
          prop="spaceId"
        >
          <template slot-scope="scope">{{
            !scope.row.parkingId
              ? ""
              : JSON.parse(scope.row.parkingId).parkingName
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="岗位"
          prop="areaName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="泊位号" prop="spaceId">
          <template slot-scope="scope">{{
            !scope.row.spaceId ? "" : JSON.parse(scope.row.spaceId).spaceNum
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="订单号"
          prop="orderNum"
        >
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="车牌号"
          prop="plaId"
        >
          <template slot-scope="scope">{{
            !scope.row.plaId ? "" : JSON.parse(scope.row.plaId).carNumber
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="车辆类型"
          prop="carType"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="手机号"
          prop="phone"
        ></el-table-column>
        <el-table-column
          width="150px"
          label="入场时间"
          prop="beginDate"
        ></el-table-column>

        <el-table-column
          label="下单时间"
          prop="crtTime"
          width="150px"
        ></el-table-column>
        <el-table-column label="下单员" prop="crtName"></el-table-column>
        <el-table-column
          width="150px"
          label="离场时间"
          prop="endDate"
        ></el-table-column>

        <el-table-column
          width="150px"
          label="停车时长"
          prop="parkingLongTime"
        ></el-table-column>

        <el-table-column
          width="150px"
          label="结算时间"
          prop="chargeDate"
        ></el-table-column>
        <el-table-column label="结算员" prop="chargeId">
          <template slot-scope="scope">{{
            !scope.row.chargeId ? "" : JSON.parse(scope.row.chargeId).name
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="第三方支付单号"
          prop="udId"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="应收金额"
          prop="shouldMoney"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="实收金额"
          prop="actualMoney"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="欠费金额"
          prop="arrearsMoney"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="补缴金额"
          prop="suppleMoney"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="支付类型"
          prop="payType"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="订单状态"
          prop="orderStatus"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="订单类型"
          prop="orderType"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="是否欠费"
          prop="arrearsFlag"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="上传人"
          prop="picsOperator"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="300px">
          <template slot-scope="scope">
            <button
              type="button"
              @click="modifyPlate(scope.row)"
              v-bind:class="[
                scope.row.isModifyPlateDisabled ? 'is-gray' : '',
                'operate-button',
              ]"
              :disabled="scope.row.isModifyPlateDisabled"
            >
              修改车牌
            </button>
            <button type="button" @click="modifyPhoto(scope.row)" class="photo">
              修改图片
            </button>
            <button
              type="button"
              @click="showPhoto(scope.row.platenumImage)"
              class="photo"
            >
              查看图片
            </button>
            <button type="button" @click="viewDetail(scope.row)" class="photo">
              查看详情
            </button>
            <button
              v-if="buttonPermissions.btn_clear"
              type="button"
              @click="clearOrder(scope.row.orderId, scope.row.orderStatus)"
              :class="[
                'operate-button',
                !canOneCancel(scope.row) ? 'is-gray' : '',
              ]"
              :disabled="!canOneCancel(scope.row)"
            >
              冲销
            </button>
            <!-- <button
              type="button"
              class="operate-button"
              @click="clearOrder(scope.row.orderId, scope.row.orderStatus)"
            >
              消除
            </button> -->
            <!-- <button
              v-if="buttonPermissions.btn_del"
              type="button"
              class="delete"
              @click="delOrder(scope.row.orderId, scope.row.orderStatus)"
              :style="{color: scope.row.orderStatus==='已完成'
                    ? 'gray !important'
                    : '#278CD8 !important',}"
            > -->
            <button
              v-if="buttonPermissions.btn_del"
              type="button"
              @click="delOrder(scope.row.orderId, scope.row.orderStatus)"
              :class="['delete', !canOneException(scope.row) ? 'is-gray' : '']"
              :disabled="!canOneException(scope.row)"
            >
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
    <!--上传图片 -->
    <upload-photo
      :uploadPhotoDialogVisible="modifyPhotoDialogVisible"
      :oneOrder="oneOrder"
      @func="closeDialog"
    >
    </upload-photo>
    <!--查看图片-->

    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        ref="show"
        height="80%"
        :visible.sync="photoDialogVisible"
        :show-close="false"
        @closed="hiddenShade"
        @opened="showImg"
      >
        <div slot="footer">
          <span v-show="photoY" ref="spanImg" class="img-container">
            <img ref="img1" src width="50%" height="auto" />
            <img ref="img2" src width="50%" height="auto" />
          </span>
          <span class="photoN" v-show="photoN">暂无图片</span>
        </div>
      </el-dialog>
    </div>
    <!-- <el-image-viewer
      v-if="imgViewerVisible"
      :on-close="closeImgViewer"
      :url-list="imgList"
    >
    </el-image-viewer> -->
    <el-dialog
      title="修改车牌"
      :visible.sync="modifyPlateVisible"
      width="30%"
      class="modify-plate"
    >
      <el-form label-width="120px" :model="modifyPlateForm">
        <el-form-item label="订单编号：">
          <el-input v-model="modifyPlateForm.orderId" disabled></el-input>
        </el-form-item>
        <el-form-item label="车牌类型：">
          <el-select v-model="modifyPlateForm.carType" placeholder="请选择">
            <el-option
              v-for="item in carTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现车牌：">
          <el-input v-model="modifyPlateForm.carNumberOld" disabled></el-input>
        </el-form-item>
        <el-form-item label="更改为车牌：">
          <el-input v-model="modifyPlateForm.carNumber"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPlateVisible = false">取 消</el-button>
        <el-button type="primary" @click="onModifyPlateTrue">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <!--修改车牌-->
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import UploadPhoto from "./components/uploadPhoto.vue";
import {
  delOrder,
  getAllOrderStatus,
  getAllPayTypes,
  getAllChargeUsers,
  dictValue,
  getOrderList,
  clearOrder,
  reqModifyPlate,
  batchCancelOrders,
} from "@/api/url";

import Page from "../../commons/page";
import SearchParking from "../../commons/searchParking/index";
import SearchArea from "../../commons/searchArea";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
// import Refresh from "../commons/refresh.vue";
import AreaTree from "../../commons/areaTree";
import systemConfig from "@/utils/globalVal";
import { MessageBox } from "element-ui";
import dayjs from "dayjs";
const FORBID_CANCEL = [
  "cancel", //已冲销
  "complete", //已完成
  "canceling", //冲销申请中
  "excepting", //删除申请中
  "exception", //异常结束
];
const FORBID_EXCEPTION = [
  "cancel", //已冲销
  "canceling", //冲销申请中
  "excepting", //删除申请中
  "exception", //异常结束
];
export default {
  data() {
    return {
      isActived: true,
      modifyPlateVisible: false,
      imgViewerVisible: false,
      systemConfigData: systemConfig,
      carTypeList: [
        {
          label: "汽车",
          value: "auto",
        },
        {
          label: "大车",
          value: "truck",
        },

        {
          label: "特大车",
          value: "oversize",
        },
      ],
      modifyPlateForm: {
        carType: "auto",
      },
      styleObj: {
        "text-align": "center",
      },
      oneOrder: {},
      moduleName: "",
      srcList: [],
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      selectedList: [],
      treeData: {
        parkingId: "",
      },
      modifyPhotoDialogVisible: false,
      allOrderType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        orderNum: "",
        carNumber: "",
        chargeId: "",
        orderStatus: "",
        payType: "",
        spaceNum: "",
        beginTime: [],
        chargeDate: [],
        attr3: "",
        overTime: "",
        phone: "",
        crtTime: [],
        orderType: "",
        crtUser: "",
      },
      tableListData: {},
      totalMap: {},
      tableListDataAll: {},
      downloadFileds: {
        订单号: "orderNum",
        下单时间: "crtTime",
        结算时间: "chargeDate",
        结算员: {
          field: "chargeId",
          callback: (value) => {
            return !value ? "" : JSON.parse(value).name;
          },
        },
        车牌号: {
          field: "plaId",
          callback: (value) => {
            return !value ? "" : JSON.parse(value).carNumber;
          },
        },
        金额: "realMoney",
        支付类型: "payType",
        泊位号: {
          field: "spaceId",
          callback: (value) => {
            return !value ? "" : JSON.parse(value).spaceNum;
          },
        },
      },
      allChargeUsers: {},
      allOrderStatus: {},
      allPayTypes: [],
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      photoShow: false,
      imgList: [],
      buttonPermissions: {
        btn_del: false,
        btn_clear: false,
      },
      pageObj: {},
      loading: false,
    };
  },
  components: {
    Page,
    UploadPhoto,
    AreaTree,
    SearchParking,
    SearchArea,
    elImageViewer,
  },
  activated() {
    console.log("order activated");
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      area: (state) => state.parking.area,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    canBatchCancel: function() {
      return (
        this.selectedList.length === 0 ||
        !this.selectedList.some((order) => this.canOneCancel(order))
      );
    },
    canBatchException: function() {
      return (
        this.selectedList.length === 0 ||
        !this.selectedList.some((order) => this.canOneException(order))
      );
    },
  },

  created: function() {
    // var curPath = this.$router.currentRoute.path;
    // if (curPath == "/main/order/running") {
    //   this.search.status = "running";
    // } else if (curPath == "/main/order/complete") {
    //   this.search.status = "complete";
    // } else if (curPath == "/main/order/unpay") {
    //   this.search.status = "unpay";
    // } else if (curPath == "/main/order/all") {
    //   this.search.status = "all";
    // }
    // this.tableListAll();
  },
  mounted: function() {
    // this.search.pageNumber = 1;
    // this.tableList(this.search.pageNumber);
    // this.tableListAll();
    console.log("mounted order");
    this.getOrderType();
    this.getAllOrderStatus();
    this.getAllPayTypes();
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss();
      },
      deep: true, //深度
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    handleOrderStatus(v) {
      for (let item of this.allOrderStatus.rows) {
        if (v == item.value) {
          return item.labelDefault;
        }
      }
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function(node, data) {
    //   this.search.orderNum = "";
    //   this.search.carNumber = "";
    //   this.search.chargeId = "";
    //   this.search.orderStatus = "";
    //   this.search.beginDate = "";
    //   this.search.chargeDate = "";
    //   if (node.type != "parking") {
    //     this.treeData.parkingId = "";
    //     var pageObj = {
    //       curIndex: 1,
    //       rowsCount: 0
    //     };
    //     this.getPage(pageObj);
    //     this.tableListData = null;
    //     // this.$message({
    //     // 	message: '请选择车场',
    //     // 	type: 'warning'
    //     // });
    //     return;
    //   } else {
    //     this.treeData.parkingId = node.id;
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   }
    // },
    selectBeginDate(value) {},
    getAllOrderStatus() {
      this.$get(getAllOrderStatus()).then((data) => {
        this.allOrderStatus = data.data;
      });
    },
    //获取支付类型
    getAllPayTypes() {
      this.$get(getAllPayTypes()).then((data) => {
        const types = (data?.data?.rows ?? []).map(({ value, labelZhCh }) => ({
          key: value,
          label: labelZhCh,
        }));
        this.allPayTypes = types;
      });
    },
    getAllChargeUsers() {
      this.$get(getAllChargeUsers(), {
        parkingId: this.treeData.parkingId,
        limit: 0,
        isDeleted: 0,
      }).then((data) => {
        this.allChargeUsers = data.data.rows;
      });
    },
    showPhoto(url) {
      this.photoDialogVisible = true;
      const urls = url.split(",");

      this.$refs.imgDialog.style.height = "100vh";
      this.$refs.imgDialog.style.width = "100vw";
      this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";

      if (urls.length <= 0) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img1.src = urls[0];
        this.$refs.img2.src = urls[1];
      }

      // this.imgDialog.url = url;
      this.$refs.show.open();
      // console.log(img)
      // ctx.drawImage(img,0,0);
      // window.open(url,'_blank');

      // this.imgViewerVisible = true;
      // this.imgList = url.split(",");
      // const m = (e) => {
      //   e.preventDefault();
      // };
      // document.body.style.overflow = "hidden";
      // document.addEventListener("touchmove", m, false); //禁止页面滑动
    },
    // closeImgViewer(){
    //   this.imgViewerVisible = false;
    //   const m = (e) => { e.preventDefault() };
    //   document.body.style.overflow = 'auto';
    //   document.removeEventListener("touchmove", m, true);
    // },

    showImg() {
      // console.log("6666")
    },
    getOrderType: function() {
      this.$get(dictValue() + "/order_type").then((data) => {
        this.allOrderType = data.data.rows;
      });
    },
    clearOrder(id, status) {
      var _this = this;
      var index = _this.$layer.confirm(
        "是否确认冲销订单费用",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);

          _this.$postRequest(clearOrder() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("冲销申请失败", { time: 1 });
            _this.$notify({
              type: "success",
              title: "成功",
              message: "冲销申请成功",
            });
            _this.tableList(_this.pageObj.curIndex);
          });
        }
      );
    },
    checkSearch() {
      if (this.search.orderNum) return true;
      if (this.search.carNumber) return true;
      //判断进出场时间是否存在
      if (!(this.search.beginDate || this.search.chargeDate)) {
        this.$message({
          type: "warning",
          message: "进场时间，结算时间必选其一,且在一个月内",
        });
        return false;
      }

      //如果进场时间存在，是否在一个月内
      if (this.search?.beginDate && !this.search?.chargeDate) {
        const [date1, date2] = this.search?.beginDate;

        if (dayjs(date2).diff(dayjs(date1), "day") > 30) {
          this.$message({
            type: "warning",
            message: "时间在一个月内",
          });
          return false;
        }
      }
      //如果出场时间存在，是否在一个月内
      if (this.search?.chargeDate && !this.search?.beginDate) {
        const [date1, date2] = this.search?.chargeDate;
        if (dayjs(date2).diff(dayjs(date1), "day") > 30) {
          this.$message({
            type: "warning",
            message: "时间在一个月内",
          });
          return false;
        }
      }
      //如果进出场时间都存在
      if (this.search?.chargeDate && this.search?.beginDate) {
        const [chargeDate1, chargeDate2] = this.search?.chargeDate;
        const [beginDate1, beginDate2] = this.search?.beginDate;
        if (
          dayjs(chargeDate2).diff(dayjs(chargeDate1), "day") > 30 &&
          dayjs(beginDate2).diff(dayjs(beginDate1), "day") > 30
        ) {
          this.$message({
            type: "warning",
            message: "进场时间，结算时间必有其一在一个月内",
          });
          return false;
        }
      }
      return true;
    },
    delOrder: function(id, status) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该订单吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this
            .$deleteRequest(delOrder(), {
              orderId: id,
              enabledFlag: "n",
            })
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除申请失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除申请成功",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },

    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
    tableList: function(curPage) {
      this.loading = true;
      let parkingId, areaId;
      if (this.parking) {
        parkingId = this.parking.parkingId;
      }
      if (this.area) {
        areaId = this.area.areaId;
      }
      var _this = this;
      // console.log(this.search.beginDate)
      // console.log(JSON.stringify(this.search.beginDate))
      // console.log(JSON.parse(JSON.stringify(this.search.beginDate)))
      let params = {
        parkingId,
        areaId,
        limit: this.search.pageSize,
        page: curPage,
        chargeId: this.search.chargeId,
        orderNum: this.search.orderNum,
        carNumber: this.search.carNumber,
        orderStatus: this.search.orderStatus,
        payType: this.search.payType,
        spaceNum: this.search.spaceNum,
        attr3: this.search.attr3,
        orderType: this.search.orderType,
        beginTime:
          !this.search.beginTime || this.search.beginTime.length == 0
            ? null
            : JSON.stringify(
                this.search.beginTime.map((date) => this.formatDate(date))
              ),
        crtTime:
          !this.search.crtTime || this.search.crtTime.length == 0
            ? null
            : JSON.stringify(
                this.search.crtTime.map((date) => this.formatDate(date))
              ),
        chargeTime:
          !this.search.chargeDate || this.search.chargeDate.length == 0
            ? null
            : JSON.stringify(
                this.search.chargeDate.map((date) => this.formatDate(date))
              ),
        overTime: this.search.overTime,
        phone: this.search.phone,
        crtUser: this.search.crtUser,
      };
      // if (systemConfig.ORDER_SEARCH_PLACE_TIME) {
      //   params = {
      //     ...params,
      //     crtTimeData:
      //       JSON.stringify(this.search?.crtTimeData ?? undefined) ?? null,
      //   };
      // }
      this.$get(getOrderList(), {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          // var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          // _this.getPage(pageObj);
          _this.pageObj = { ...pageObj };
          const rows = (data?.data?.rows ?? []).map((order) => {
            order.isModifyPlateDisabled =
              order.orderStatus === "进行中" || order.orderStatus === "待支付"
                ? false
                : true;

            return order;
          });
          _this.tableListData = {
            ...data?.data,
            rows,
          };
          _this.totalMap = data.data.totalMap;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      // var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      // if (flTime) {
      //   return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      // } else if (
      //   !Boolean(this.search.startTime) &&
      //   Boolean(this.search.endTime)
      // ) {
      //   return this.$layer.msg("请选择开始时间", { time: 1 });
      // } else if (
      //   Boolean(this.search.startTime) &&
      //   !Boolean(this.search.endTime)
      // ) {
      //   return this.$layer.msg("请选择结束时间", { time: 1 });
      // }

      // if (!this.treeData.parkingId) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择车场"
      //   });
      //   return;
      // }
      // if(!this.checkSearch()) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    // timeCompare: function(bDateVal, eDateVal) {
    //   // console.log(bDateVal,eDateVal);

    //   if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
    //     return false;
    //   }
    //   var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
    //   bdate = bdate.getTime();
    //   var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
    //   edate = edate.getTime();
    //   if (bdate - edate > 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    // isChecked(ifAll){//选择需批处理的项
    // 	this.batchDel=[];
    // 	switch(ifAll){
    // 		case 'checkBox':
    // 			for(let i=0;i<this.$refs.checkBox.length;i++){
    // 				if((this.$refs.checkBox)[i].checked){
    // 					this.batchDel.push(this.tableListData.rows[i].orderId)
    // 				}else{
    // 					let index=this.batchDel.indexOf(this.tableListData.rows[i].orderId);
    // 					if(index>-1){
    // 						this.batchDel.splice(index,1);
    // 					}
    // 				}
    // 			};
    // 			break;
    // 		case 'checkBoxAll':
    // 			if((this.$refs.checkBoxAll).checked){
    // 				for(var i=0;i<this.tableListData.rows.length;i++){
    // 					this.batchDel.push(this.tableListData.rows[i].orderId);
    // 					(this.$refs.checkBox)[i].checked=true;
    // 				}
    // 			}else{
    // 				this.batchDel=[];
    // 				this.$refs.checkBox.forEach(function(item){
    // 					item.checked=false;
    // 				})
    // 			};
    // 			break;
    // 		default:
    // 			break;

    // 	}
    // 	console.log(this.batchDel)
    // },
    onSelectionChange(val) {
      this.selectedList = [...val];
    },
    executeBatchEliminate() {
      const orders = this.selectedList.filter((order) =>
        this.canOneCancel(order)
      );

      const orderIds = orders.map((order) => order.orderId);
      const orderNums = orders.map((order) => order.orderNum);

      MessageBox.confirm(
        `此操作将冲销订单号为${orderNums.join(",") ?? ""}的订单, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          return this.$postRequest(batchCancelOrders(), orderIds);
        })
        .then((data) => {
          if (data?.status == 200) {
            this.$message({
              type: "success",
              message: "批量冲销申请成功!",
            });
            this.tableList(this.pageObj.curIndex);
            this.selectedList = [];
          }
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error,
          });
        });
    },
    executeBatchDel() {
      const orders = this.selectedList.filter((order) =>
        this.canOneException(order)
      );

      const orderIds = orders.map((order) => order.orderId);
      const orderNums = orders.map((order) => order.orderNum);

      this.$deleteRequest(delOrder(), {
        orderId: orderIds.join(",") ?? "",
        enabledFlag: "n",
      }).then((data) => {
        if (data.status == 200) {
          this.$notify({
            type: "success",
            message: "批量删除申请成功！",
            title: "成功",
          });
          this.tableList(this.pageObj.curIndex);
          this.selectedList = [];
          // if (this.$refs.checkBoxAll.checked) {
          //   this.$refs.checkBoxAll.checked = false;
          // }
        }
      });
    },
    downloadExcel() {
      // if(!this.checkSearch()) return;
      const {
        chargeId,
        orderNum,
        carNumber,
        orderStatus,
        payType,
        spaceNum,
        beginTime,
        crtTime,
        chargeDate,
        attr3,
        overTime,
        phone,
        crtUser,
      } = this.search;
      let queryPramas = {
        parkingId: this.parking?.parkingId ?? null,
        areaId: this.area?.areaId ?? null,
        chargeId: chargeId ? chargeId : null,
        orderNum: orderNum ? orderNum : null,
        carNumber: carNumber ? carNumber : null,
        orderStatus: orderStatus ? orderStatus : null,
        payType: payType ? payType : null,
        spaceNum: spaceNum ? spaceNum : null,
        attr3: attr3 ? attr3 : null,
        beginTime:
          !this.search.beginTime || this.search.beginTime.length == 0
            ? null
            : JSON.stringify(
                this.search.beginTime.map((date) => this.formatDate(date))
              ),
        crtTime:
          !this.search.crtTime || this.search.crtTime.length == 0
            ? null
            : JSON.stringify(
                this.search.crtTime.map((date) => this.formatDate(date))
              ),
        chargeTime:
          !this.search.chargeDate || this.search.chargeDate.length == 0
            ? null
            : JSON.stringify(
                this.search.chargeDate.map((date) => this.formatDate(date))
              ),
        overTime: overTime ? overTime : null,
        phone: phone ? phone : null,
        crtUser: crtUser ? crtUser : null,
      };
      if (systemConfig.ORDER_SEARCH_PLACE_TIME) {
        queryPramas = {
          ...queryPramas,
          crtTimeData:
            JSON.stringify(this.search?.crtTimeData ?? undefined) ?? null,
        };
      }
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/orderExport",
        queryPramas,
        "订单管理"
      );
      //   window.open(`/api/parking/parkingOrders/orderExport?crtTime=${!beginDate
      //         ? null
      //         : JSON.stringify(this.search.beginDate)}&chargeTime=${!chargeDate
      //         ? null
      //         : JSON.stringify(this.search.chargeDate)}`,'_blank')
    },
    modifyPhoto(row) {
      const { platenumImage, orderId } = row;
      this.oneOrder = {
        pics: platenumImage ? platenumImage.split(",") : [],
        orderId,
      };
      this.modifyPhotoDialogVisible = true;
    },
    closeDialog(m) {
      if (m === "success") {
        this.tableList(this.pageObj.curIndex);
      }
      this.modifyPhotoDialogVisible = false;
    },
    permiss() {
      this.buttonPermissions.btn_del = this.elements["running:btn_del"];
      this.buttonPermissions.btn_clear = this.elements["running:btn_clear"];
    },
    modifyPlate(order) {
      this.modifyPlateForm = {
        carType: "auto",
      };
      this.modifyPlateForm = {
        ...this.modifyPlateForm,
        orderId: order?.orderId,
        carNumberOld: JSON.parse(order?.plaId ?? "{}")?.carNumber,
      };
      this.modifyPlateVisible = true;
    },
    onModifyPlateTrue() {
      const { orderId, carType, carNumber } = this.modifyPlateForm;
      this.$postRequest(reqModifyPlate(), {
        orderId,
        carType,
        carNumber,
      }).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: "车牌修改成功",
          });
          this.modifyPlateVisible = false;
          this.tableList(this.pageObj.curIndex);
        } else {
          this.$message({
            type: "warning",
            message: "车牌修改失败",
          });
        }
      });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计";
        }
        if (index === 16) {
          sums[index] = this.totalMap?.shouldMoneyTotal ?? 0;
        }
        if (index === 17) {
          sums[index] = this.totalMap?.actualMoneyTotal ?? 0;
        }
        if (index === 18) {
          sums[index] = this.totalMap?.arrearsMoneyTotal ?? 0;
        }
        if (index === 19) {
          sums[index] = this.totalMap?.suppleMoneyTotal ?? 0;
        }
      });
      return sums;
    },
    onCurrentDatetimeChange(v, type) {
      if (type === "beginTime") {
        this.search.beginTime = [...v];
      }
      if (type === "crtTime") {
        this.search.crtTime = [...v];
      }
      if (type === "chargeDate") {
        this.search.chargeDate = [...v];
      }
    },
    canOneCancel: function(row) {
      const { orderStatus } = row;
      return !FORBID_CANCEL.some(
        (item) =>
          item ===
          ((this.allOrderStatus?.rows ?? []).find(
            (s) => s.labelZhCh === orderStatus
          )?.value ?? "")
      );
    },
    canOneException: function(row) {
      const { orderStatus } = row;
      return !FORBID_EXCEPTION.some(
        (item) =>
          item ===
          ((this.allOrderStatus?.rows ?? []).find(
            (s) => s.labelZhCh === orderStatus
          )?.value ?? "")
      );
    },
    viewDetail(row) {
      this.$router.push({
        path: "/main/order/detail",
        query: { orderNum: row.orderNum },
      });
    },
  },
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
  /* height:150px; */
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
		width:60px;
		font-size:12px;
		background:#409EFF;
		color:white;
		height:20px;
		line-height:20px;
		
	} */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
</style>
<style>
.order .el-date-editor {
  width: 250px !important;
}

.order .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.order .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.order .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.order .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.order .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.order .searchbox .el-select {
  width: 150px !important;
}

.order .order_searchbox .form-control {
  width: 150px;
}
.order .order_searchbox form {
  height: auto;
}

.order .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
	 display: inline-block;;
    cursor: pointer;
	color:white;
	background:#278cd8;
	height:34px;
	border-radius: 5px;
	padding-left:5px;
	font-size: 12px;
	line-height:37px;
	width:90px;
  } */
.order .el-icon-arrow-down {
  font-size: 12px;
}

.order .dowload {
  padding-left: 10px;
  display: inline-block;
}

.order .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.order img {
  overflow: hidden;
}

.order .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.order .searchbox .form-inline {
  overflow: auto;
}
.order .is-gray {
  color: #666;
  cursor: not-allowed !important;
}
.gap {
  margin-right: 5px;
}
.order-record .list-right {
  height: calc(100vh - 290px);
}
</style>
<style>
.order .modify-plate .el-input__inner {
  height: 40px;
}
.order .modify-plate .el-select {
  width: 100%;
}
.order .btn:focus {
  outline: none;
  background: none;
  color: #278cd8;
}

.order .el-table__footer-wrapper {
  font-weight: bold;
  font-size: 24px;
}
.order .el-table__footer-wrapper tbody td {
  color: red;
  text-align: center;
}
.order-record .batchDel_btn .btn:hover,
.order-record .batchDel_btn .btn:focus {
  color: #278cd8;
  border: 1px solid #278cd8;
  background: white;
}
</style>
